import { Button, Modal } from 'react-daisyui';

const AppointmentModal = ({ open, loading = false, onClose, onConfirm }) => {
  const handleConfirm = async () => {
    try {
      await onConfirm();
      onClose();
    } catch {}
  };

  return (
    <Modal
      open={open}
      onClose={onClose}
      backdrop
      className="max-w-md rounded-2xl border border-gray-100 shadow-2xl"
    >
      <Modal.Body>
        <div className="mx-auto mb-4 flex h-12 w-12 items-center justify-center rounded-full bg-green-100 text-green-700">
          ✓
        </div>
        <h3 className="text-lg font-bold text-secondary-900 text-center">Confirm appointment?</h3>
        <p className="text-sm text-secondary-500 text-center mt-2">
          Please confirm that you will attend this appointment.
        </p>
        <Modal.Actions className="grid grid-cols-2 gap-3">
          <Button type="button" onClick={onClose} disabled={loading} color="ghost">
            Cancel
          </Button>
          <Button
            type="button"
            onClick={handleConfirm}
            disabled={loading}
            loading={loading}
            color="success"
            className="text-white"
          >
            {loading ? '' : 'Yes, confirm'}
          </Button>
        </Modal.Actions>
      </Modal.Body>
    </Modal>
  );
};

export default AppointmentModal;
